import { render, staticRenderFns } from "./OrganizationFields.vue?vue&type=template&id=38cec235&lang=pug"
import script from "./OrganizationFields.vue?vue&type=script&lang=ts"
export * from "./OrganizationFields.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports